
export const list = state => state.list;
export const actived = state => state.actived;
export const isLoad = state => state.isLoad;
export const activeNew = state => state.activeNew;
export const providers = state => state.providers;
export const products = state => state.products;
export const showAmount = state => state.showAmount;
export const showNumber = state => state.showNumber;
export const showSubmit = state => state.showSubmit;
export const showLoad = state => state.showLoad;
export const recharge = state => state.recharge;
export const showError = state => state.showError;
export const errors = state => state.errors;
export const showSuccess = state => state.showSuccess;
export const showConfirm = state => state.showConfirm;
export const showCancel = state => state.showCancel;
